import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SavedSearchModalService {

  private searchDataSubject = new BehaviorSubject<any>(null);
  public searchData$ = this.searchDataSubject.asObservable();

  constructor() { }

  setSearchData(data: any): void {
    this.searchDataSubject.next(data);
  }

  getSearchData(): any | null {
    return this.searchDataSubject.value;
  }

  clearSearchData(): void {
    this.searchDataSubject.next(null);
  }
}

